<template>
  <div class="p-4">
    <div class="border-b border-gray-200">
      <nav class="-mb-px flex space-x-4" aria-label="Tabs">
        <button
          v-for="(tab, index) in tabs"
          :key="index"
          @click="switchTab(tab.name)"
          :data-cy="`tab-${tab.urlParam}`"
          :class="[
            activeTab === tab.name
              ? 'border-blue-500 text-blue-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
            'whitespace-nowrap py-2 px-4 border-b-2 font-medium text-sm focus:outline-none'
          ]"
        >
          {{ tab.label }}
        </button>
      </nav>
    </div>

    <div class="mt-4">
      <Orders v-if="activeTab === 'tab1'" class="p-4" />
      <Tasks v-if="activeTab === 'tab2'" class="p-4" />
      <Specifications v-if="activeTab === 'tab3'" class="p-4" />
    </div>
  </div>
</template>

<script>
import Specifications from "@/components/production/TechMaps.vue";
import Tasks from "@/components/production/Tasks.vue";
import Orders from "@/components/production/Orders.vue";

export default {
  components: {
    Specifications,
    Tasks,
    Orders,
  },
  data() {
    return {
      activeTab: "tab1",
      tabs: [
        { label: "Заказы на производство", name: "tab1", urlParam: "orders" },
        { label: "Задания на комплектование", name: "tab2", urlParam: "tasks" },
        { label: "Спецификации", name: "tab3", urlParam: "specifications" },
      ],
    };
  },
  created() {
    this.syncTabFromRoute();
  },
  watch: {
    '$route'(to, from) {
      // Синхронизация при изменении маршрута (браузерная история)
      if (to.query.tab !== from.query.tab) {
        this.syncTabFromRoute();
      }
    }
  },
  methods: {
    /**
     * Переключение на указанный таб. Сначала обновляем URL (только tab — page/trashed сбрасываются),
     * затем переключаем таб — дочерний компонент монтируется уже с правильным URL.
     */
    switchTab(tabName) {
      if (this.activeTab === tabName) return;

      const targetTab = this.tabs.find(tab => tab.name === tabName);
      if (!targetTab) return;

      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: { tab: targetTab.urlParam }
      }).then(() => {
        this.activeTab = tabName;
      }).catch(() => {});
    },

    /**
     * Синхронизация активного таба с URL-параметрами
     */
    syncTabFromRoute() {
      const urlTab = this.$route.query.tab;
      
      if (urlTab) {
        // Ищем таб по urlParam
        const foundTab = this.tabs.find(tab => tab.urlParam === urlTab);
        if (foundTab) {
          this.activeTab = foundTab.name;
        } else {
          // Fallback на таб по умолчанию при некорректном параметре
          this.activeTab = "tab1";
        }
      } else {
        // Fallback на таб по умолчанию при отсутствии параметра
        this.activeTab = "tab1";
      }
    },

  }
};
</script>
